import { render } from "./Routes.vue?vue&type=template&id=01a70377&scoped=true&ts=true"
import script from "./Routes.vue?vue&type=script&lang=ts"
export * from "./Routes.vue?vue&type=script&lang=ts"

import "./Routes.vue?vue&type=style&index=0&id=01a70377&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a70377"]])

export default __exports__